export var TagSize;
(function (TagSize) {
    TagSize["Small"] = "small";
    TagSize["Medium"] = "medium";
    TagSize["Large"] = "large";
})(TagSize || (TagSize = {}));
export var TagVariant;
(function (TagVariant) {
    TagVariant["Light"] = "light";
    TagVariant["Info"] = "info";
    TagVariant["Primary"] = "primary";
    TagVariant["Secondary"] = "secondary";
    TagVariant["Success"] = "success";
    TagVariant["Error"] = "error";
    TagVariant["Warning"] = "warning";
    TagVariant["Neu"] = "neu";
})(TagVariant || (TagVariant = {}));
